import * as React from 'react';
import { cn } from '@noor/lib/cn';

/**
 * The centered content column inside a `PageShell`. Caps content at a
 * comfortable reading width (1600px) and centers it, so wide screens don't
 * stretch a dashboard or card edge-to-edge. Pair it with `PageShell`, which
 * owns the page padding and scroll.
 *
 * - `scroll` (default) — a plain centered block for content that flows
 *   (dashboards, the venue card).
 * - `fill` — a centered flex column that fills the shell's height, for
 *   full-height table pages whose body scrolls internally. Give the child that
 *   should absorb the slack `flex-1 min-h-0`.
 */
function PageContainer({
  variant = 'scroll',
  className,
  ...props
}: React.ComponentProps<'div'> & { variant?: 'scroll' | 'fill' }) {
  return (
    <div
      data-slot="page-container"
      data-variant={variant}
      className={cn(
        'mx-auto w-full max-w-[1600px]',
        variant === 'fill' && 'flex min-h-0 flex-1 flex-col',
        className,
      )}
      {...props}
    />
  );
}

export { PageContainer };
